import { createContext } from "react";

export type FormData = {
  comments: string[];
};

export const FormDataContext = createContext<FormData | undefined>(undefined);
